import { Vestiging } from "@/entities/vestiging";
import { useMemo } from "react";
import { BaseFaciliteitenTable, StationHeader, VestigingenUpdateHandler } from "../../shared";
import { createColumns } from "./columns-factory";

interface FaciliteitenDetailsForStationProps {
    variant: "startNsRetailVestiging" | "stopNsRetailVestiging" | "lokaleVestiging";
    stationCode: string;
    vestigingen: Vestiging[];
    onVestigingUpdate: VestigingenUpdateHandler;
    onLocalToelichtingChange?: (vestiging: Vestiging, toelichting: string) => void;
}

export function FaciliteitenDetailsForStation({
    variant,
    stationCode,
    vestigingen,
    onVestigingUpdate,
    onLocalToelichtingChange,
}: Readonly<FaciliteitenDetailsForStationProps>) {
    const columns = useMemo(
        () =>
            createColumns(variant, {
                onVestigingUpdate,
                onLocalToelichtingChange,
            }),
        [onLocalToelichtingChange, onVestigingUpdate, variant]
    );

    return (
        <div className="space-y-4">
            <StationHeader stationCode={stationCode} />
            <BaseFaciliteitenTable
                stationCode={stationCode}
                vestigingen={vestigingen}
                columns={columns}
                columnWidths={variant === "lokaleVestiging" ? ["45%", "17%", "38%"] : ["45%", "45%", "5%", "5%"]}
            />
        </div>
    );
}
